import thunk from 'redux-thunk';
import { unstable_batchedUpdates } from 'react-dom';
import { batchedSubscribe } from 'redux-batched-subscribe';
import rootReducer from './rootReducer';
import { pendingAPIReducerMiddleware } from '../main/platform/dashboards/pendings/ducks';
import { notificationAPIReducerMiddleware } from '../main/platform/dashboards/notifications/ducks';
import { analyticsAPIReducerMiddleware } from '../main/platform/dashboards/overview/ducks';
import {
    eventsAPIReducerMiddleware,
    causesAPIReducerMiddleware,
} from '../main/platform/dashboards/overview/eventView/ducks';
import { configureStore } from '@reduxjs/toolkit';
import { versionAPIReducerMiddleware } from '../main/ducks';
import { maintenanceEventAPIReducerMiddleware } from '../main/platform/dashboards/pendings/ducks/maintenanceEvent';
import { assetLifecycleAPIReducerMiddleware } from '../main/platform/dashboards/pendings/ducks/assetLifecycle';
import { alarmsAPIReducerMiddleware } from '../main/platform/dashboards/alarms/ducks';
import { reportsAPIReducerMiddleware } from '../main/platform/dashboards/reports/ducks';
import {
    hardwareAPIReducerMiddleware,
    hardwareLegacyAPIReducerMiddleware,
} from '../main/platform/dashboards/reports/ducks/hardwareDuck';
import {
    diagnosticsAPIReducerMiddleware,
    findingsAPIReducerMiddleware,
    problemsAPIReducerMiddleware,
} from '../main/platform/dashboards/analysis/ducks';
import { usersAPIReducerMiddleware } from '../main/platform/dashboards/User/ducks';
import { configurationAPIReducerMiddleware } from '../main/platform/dashboards/configuration/ducks';
import { messagesAPIReducerMiddleware } from '../main/platform/dashboards/inbound_messages/ducks';
import { bearingsAPIReducerMiddleware } from '../main/platform/dashboards/configuration/ducks/bearingsData';
import { dashboardsAPIReducerMiddleware } from '../main/platform/dashboards/analytics/ducks';
import { feedAPIReducerMiddleware } from '../main/platform/dashboards/feed/ducks';
import { cardEventsAPIReducerMiddleware } from '../main/platform/dashboards/components/cardEvents/ducks';
import { internationalizationAPIReducerMiddleware } from '../main/platform/ducks/translations';
import { mediaAPIReducerMiddleware } from '../main/platform/dashboards/overview/ducks/mediaDuck';
import { orientationAPIReducerMiddleware } from '../main/platform/dashboards/analysis/ducks/orientationDuck';
import { bestPracticeAPIReducerMiddleware } from '../main/platform/dashboards/analysis/ducks/bestPracticeDuck';
import { installationAPIReducerMiddleware } from '../main/platform/dashboards/configuration/ducks/installations';
import { exportAPIReducerMiddleware } from '../main/platform/dashboards/diagnostics/ducks/export';
import { annotationsAPIReducerMiddleware } from '../main/platform/dashboards/analysis/ducks/annotationsDuck';
import { measurementsV3APIReducerMiddleware } from '../main/platform/dashboards/analysis/ducks';
import { spectralBandsAPIReducerMiddleware } from '../main/platform/dashboards/analysis/ducks/spectralBandsDuck';
import { odmAPIReducerMiddleware } from '../main/platform/dashboards/analysis/ducks/odm';
import { devicesAPIReducerMiddleware } from '../main/platform/dashboards/Hardware/ducks';
import { modelAPIReducerMiddleware } from '../main/platform/ducks/model';
import { authAPIReducerMiddleware } from '../main/landing/ducks';
import { reviewAPIReducerMiddleware } from '../main/platform/dashboards/analysis/ducks/review';
import { operationHoursAPIReducerMiddleware } from '../main/platform/dashboards/summary/ducks/operationHoursApi';
import { offlineAnalysisAPIReducerMiddleware } from '../main/platform/dashboards/summary/ducks/offlineAnalysisApi';

export default function configureAppStore() {
    const store = configureStore({
        reducer: rootReducer,
        middleware: [
            thunk,
            pendingAPIReducerMiddleware,
            notificationAPIReducerMiddleware,
            eventsAPIReducerMiddleware,
            causesAPIReducerMiddleware,
            analyticsAPIReducerMiddleware,
            versionAPIReducerMiddleware,
            maintenanceEventAPIReducerMiddleware,
            assetLifecycleAPIReducerMiddleware,
            alarmsAPIReducerMiddleware,
            reportsAPIReducerMiddleware,
            hardwareAPIReducerMiddleware,
            problemsAPIReducerMiddleware,
            findingsAPIReducerMiddleware,
            diagnosticsAPIReducerMiddleware,
            usersAPIReducerMiddleware,
            configurationAPIReducerMiddleware,
            messagesAPIReducerMiddleware,
            bearingsAPIReducerMiddleware,
            dashboardsAPIReducerMiddleware,
            feedAPIReducerMiddleware,
            cardEventsAPIReducerMiddleware,
            internationalizationAPIReducerMiddleware,
            mediaAPIReducerMiddleware,
            orientationAPIReducerMiddleware,
            bestPracticeAPIReducerMiddleware,
            installationAPIReducerMiddleware,
            exportAPIReducerMiddleware,
            annotationsAPIReducerMiddleware,
            hardwareLegacyAPIReducerMiddleware,
            measurementsV3APIReducerMiddleware,
            spectralBandsAPIReducerMiddleware,
            odmAPIReducerMiddleware,
            devicesAPIReducerMiddleware,
            modelAPIReducerMiddleware,
            authAPIReducerMiddleware,
            reviewAPIReducerMiddleware,
            operationHoursAPIReducerMiddleware,
            offlineAnalysisAPIReducerMiddleware,
        ],
        devTools: true,
        enhancers: [batchedSubscribe(unstable_batchedUpdates)],
    });
    return store;
}
